import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotebook2Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H17C18.6569 22 20 20.6569 20 19V5C20 3.34315 18.6569 2 17 2H16V11.7929C16 12.2383 15.4614 12.4614 15.1464 12.1464L13.3536 10.3536C13.1583 10.1583 12.8417 10.1583 12.6464 10.3536L10.8536 12.1464C10.5386 12.4614 10 12.2383 10 11.7929V2H6Z" })
});
export default SvgNotebook2Fill;
